/** UI strings for Home + shared chrome (EN/LV). Work-specific strings live with portfolio data. */
export const homeStrings = {
  en: {
    navProducts: 'Products',
    navPlatforms: 'Platforms',
    navMobile: 'Mobile',
    navWork: 'Work',
    navAbout: 'About',
    navContact: 'Contact',
    navCta: 'Contact us',
    kicker: 'GDWD — SOFTWARE PRODUCTS & OPERATIONAL PLATFORMS',
    heroTitle: 'Products and platforms built for real operations',
    heroSub:
      'GDWD designs and engineers production software — our own products, operational platforms, mobile apps, and long-term systems for education and public partners.',
    heroCta1: 'View our work',
    heroCta2: 'View products',
    trustedBy: 'Trusted by',
    trustList: 'UK college groups · University of Latvia · Ogre municipality · LUSIIC',
    badgeProduct: 'Product',
    badgePlatform: 'Platform',
    badgeCollab: 'Collaboration',
    badgeWip: 'In development',
    badgeMobile: 'Mobile',
    builtBy: 'BUILT BY GDWD',
    productsTitle: 'Products we build',
    productsLead: 'Selected products designed and engineered end-to-end by GDWD.',
    viewProduct: 'View product',
    viewSite: 'View site',
    viewPlatform: 'View platform',
    platformsTitle: 'Platforms & operational systems',
    platformsLead:
      'Long-running systems we engineer and operate — where uptime, data integrity and support matter.',
    fullcourtBlurb: 'Sports and facility operations platform — engineering and feature delivery.',
    chipSports: 'Sports ops',
    chipBookings: 'Bookings',
    chipParking: 'Parking',
    chipPayments: 'Payments',
    ukTag: 'UK HIGHER EDUCATION',
    ukTitle: 'School management systems for UK colleges',
    ukBlurb:
      'Multi-campus school management systems for UK higher education providers — admissions, enrolments, attendance, finance and day-to-day operations across college groups.',
    ukB1: 'Multi-tenant, multi-college architecture',
    ukB2: 'Admissions, enrolments, documents',
    ukB3: 'Attendance, finance, academic operations',
    ukB4: 'Long-term support & continuous delivery',
    ukLogosLabel: 'Running across college groups',
    ukNote: 'Institutional systems — public college sites available on request.',
    ukAttendanceNote: 'For staff: College Attendance — a staff Android app for class registers',
    seeMobile: 'See Mobile applications',
    mobileTitle: 'Mobile applications',
    mobileLead: 'Apps that work in the field and in class — inside real operations, not just a storefront.',
    trukkaBlurb:
      'Transport product with web ops and mobile apps — jobs, dispatch, live maps, photos and statuses.',
    attendanceBlurb:
      "Staff Android app for multi-college class registers — college select, today's classes and attendance.",
    chipMaps: 'Live maps',
    collabTitle: 'Institutional & brand collaborations',
    collabLead: 'Systems and platforms delivered with universities, municipalities and membership organisations.',
    lusiicBlurb: 'Membership and institutional systems — University of Latvia.',
    eventsTitle: 'Education events — University of Latvia · Ogre municipality',
    eventsBlurb: 'Conference and education event platforms for public-sector partners.',
    earlierLabel: 'Earlier collaborations — selected web & e-commerce projects',
    signetBlurb: 'Gallery web presence and digital showcase',
    ebBlurb: 'Beauty e-commerce storefront',
    pastWork: 'Past work',
    nextTitle: 'Building next',
    nextLead: 'New domain platforms in the pipeline — built the same way we run everything else.',
    fieldledgerBlurb:
      'Web platform for agronomy teams — farms, field boundaries on the map, soil analyses and recommendations in one ledger.',
    pilotCta: 'Contact for pilot',
    moreDetails: 'More details',
    aboutTitle: 'About GDWD',
    aboutP1:
      'GDWD builds products and long-running platforms — education AI, e-commerce, events and SaaS we ship ourselves; operational systems for parking and sports; school management for UK colleges; and collaborations with institutions, municipalities and brands.',
    aboutP2:
      'Based in Latvia, operating in the UK and EU. Small team, senior work, long-term ownership — new domain platforms always in the pipeline.',
    step1: 'Discover',
    step1d: 'Domain, users, constraints',
    step2: 'Design',
    step2d: 'Flows and system architecture',
    step3: 'Build',
    step3d: 'Ship in increments, test in production-like environments',
    step4: 'Operate',
    step4d: 'Run, support and evolve for years',
    contactTitle: 'Have an operational problem or a product idea',
    contactLead: 'Tell us what you run and where it hurts — we reply within one business day.',
    contactCta: 'Contact us',
    footerRights: 'SIA GDWD · Reg. No. 40103981811',
    workKicker: 'SELECTED WORK',
    workTitle: 'Work',
    workLead:
      'Products we ship ourselves, platforms we operate long-term, and systems built with institutional partners. Click any project to see more.',
    details: 'Details',
    close: 'Close',
    featuresLabel: 'What it does',
    metricLabel: 'One number',
    techStackLabel: 'Tech stack',
    galleryHint: 'Browse screenshots',
    filterAll: 'All',
    filterProducts: 'Products',
    filterPlatforms: 'Platforms',
    filterMobile: 'Mobile',
    filterCollab: 'Collaborations',
    filterEducation: 'Education',
    filterEcom: 'E-commerce',
    filterWip: 'In development',
    consoleLive: 'live',
    consoleWip: 'in development',
    consoleSchools: '3 college groups',
    menuOpen: 'Menu',
    menuClose: 'Close menu',
  },
  lv: {
    navProducts: 'Produkti',
    navPlatforms: 'Platformas',
    navMobile: 'Mobilās lietotnes',
    navWork: 'Darbi',
    navAbout: 'Par mums',
    navContact: 'Kontakti',
    navCta: 'Sazināties',
    kicker: 'GDWD — PROGRAMMATŪRAS PRODUKTI & OPERACIONĀLĀS PLATFORMAS',
    heroTitle: 'Produkti un platformas reālam darbam',
    heroSub:
      'GDWD projektē un būvē produkcijas programmatūru — savus produktus, operacionālās platformas, mobilās lietotnes un ilgtermiņa sistēmas izglītībai un publiskajiem partneriem.',
    heroCta1: 'Skatīt darbus',
    heroCta2: 'Skatīt produktus',
    trustedBy: 'Mums uzticas',
    trustList: 'UK koledžu grupas · Latvijas Universitāte · Ogres novads · LUSIIC',
    badgeProduct: 'Produkts',
    badgePlatform: 'Platforma',
    badgeCollab: 'Sadarbība',
    badgeWip: 'Izstrādē',
    badgeMobile: 'Mobilā lietotne',
    builtBy: 'BŪVĒJIS GDWD',
    productsTitle: 'Produkti, ko būvējam',
    productsLead: 'Izvēlēti produkti, ko GDWD izstrādājis no idejas līdz palaišanai.',
    viewProduct: 'Skatīt produktu',
    viewSite: 'Skatīt vietni',
    viewPlatform: 'Skatīt platformu',
    platformsTitle: 'Platformas & operacionālās sistēmas',
    platformsLead:
      'Ilgtermiņa sistēmas, ko būvējam un darbinām — kur svarīga pieejamība, datu integritāte un atbalsts.',
    fullcourtBlurb: 'Sporta un infrastruktūras operāciju platforma — izstrāde un funkciju piegāde.',
    chipSports: 'Sporta ops',
    chipBookings: 'Rezervācijas',
    chipParking: 'Stāvvietas',
    chipPayments: 'Maksājumi',
    ukTag: 'UK AUGSTĀKĀ IZGLĪTĪBA',
    ukTitle: 'Skolu pārvaldības sistēmas UK koledžām',
    ukBlurb:
      'Daudzu kampusu skolu pārvaldības sistēmas UK augstākās izglītības iestādēm — uzņemšana, reģistrācija, apmeklējums, finanses un ikdienas operācijas koledžu grupās.',
    ukB1: 'Multi-tenant, vairāku koledžu arhitektūra',
    ukB2: 'Uzņemšana, reģistrācija, dokumenti',
    ukB3: 'Apmeklējums, finanses, akadēmiskās operācijas',
    ukB4: 'Ilgtermiņa atbalsts & nepārtraukta piegāde',
    ukLogosLabel: 'Darbojas koledžu grupās',
    ukNote: 'Institucionālas sistēmas — koledžu publiskās vietnes pieejamas pēc pieprasījuma.',
    ukAttendanceNote: 'Skolotājiem: College Attendance — personāla Android lietotne apmeklējuma reģistriem',
    seeMobile: 'Skatīt sadaļā Mobilās lietotnes',
    mobileTitle: 'Mobilās lietotnes',
    mobileLead: 'Lietotnes, kas strādā uz lauka un klasē — reālos darba procesos, nevis tikai vitrīnā.',
    trukkaBlurb:
      'Transporta produkts ar web ops un mobilajām lietotnēm — darbi, dispečers, dzīvā karte, foto un statusi.',
    attendanceBlurb:
      'Android lietotne koledžu personālam — koledžas izvēle, šodienas nodarbības un apmeklējuma reģistri vairākām koledžām.',
    chipMaps: 'Dzīvā karte',
    collabTitle: 'Institucionālās & zīmolu sadarbības',
    collabLead: 'Sistēmas un platformas kopā ar universitātēm, pašvaldībām un biedru organizācijām.',
    lusiicBlurb: 'Biedru un institucionālās sistēmas — Latvijas Universitāte.',
    eventsTitle: 'Izglītības pasākumi — Latvijas Universitāte · Ogres novads',
    eventsBlurb: 'Konferenču un izglītības pasākumu platformas publiskā sektora partneriem.',
    earlierLabel: 'Agrākās sadarbības — izvēlēti web & e-komercijas projekti',
    signetBlurb: 'Galerijas tīmekļa klātbūtne un digitālā vitrīna',
    ebBlurb: 'Skaistumkopšanas e-komercijas vietne',
    pastWork: 'Agrāks darbs',
    nextTitle: 'Ko būvējam tālāk',
    nextLead: 'Jaunas domēnu platformas ceļā — būvētas tāpat, kā darbinām visu pārējo.',
    fieldledgerBlurb:
      'Web platforma agronomu komandām — saimniecības, lauku robežas kartē, augsnes analīzes un ieteikumi vienā reģistrā.',
    pilotCta: 'Pieteikties pilotam',
    moreDetails: 'Vairāk',
    aboutTitle: 'Par GDWD',
    aboutP1:
      'GDWD būvē produktus un ilgtermiņa platformas — izglītības AI, e-komerciju, pasākumus un SaaS, ko piegādājam paši; operacionālās sistēmas stāvvietām un sportam; skolu pārvaldību UK koledžām; un sadarbības ar institūcijām, pašvaldībām un zīmoliem.',
    aboutP2:
      'Bāzēti Latvijā, strādājam UK un ES. Maza komanda, seniora līmeņa darbs, ilgtermiņa atbildība — jaunas domēnu platformas vienmēr ceļā.',
    step1: 'Izzinām',
    step1d: 'Domēns, lietotāji, ierobežojumi',
    step2: 'Projektējam',
    step2d: 'Plūsmas un sistēmas arhitektūra',
    step3: 'Būvējam',
    step3d: 'Piegādājam pa soļiem, testējam produkcijai pietuvinātā vidē',
    step4: 'Uzturam',
    step4d: 'Darbinām, atbalstām un attīstām gadiem',
    contactTitle: 'Ir operacionāla problēma vai produkta ideja',
    contactLead: 'Pastāstiet, ko darbināt un kur spiež — atbildēsim vienas darba dienas laikā.',
    contactCta: 'Sazināties',
    footerRights: 'SIA GDWD · Reģ. Nr. 40103981811',
    workKicker: 'IZVĒLĒTIE DARBI',
    workTitle: 'Darbi',
    workLead:
      'Produkti, ko piegādājam paši, platformas, ko darbinām ilgtermiņā, un sistēmas kopā ar institucionāliem partneriem. Klikšķini uz jebkura projekta, lai redzētu vairāk.',
    details: 'Vairāk',
    close: 'Aizvērt',
    featuresLabel: 'Ko tas dara',
    metricLabel: 'Viens skaitlis',
    techStackLabel: 'Tehniskais steks',
    galleryHint: 'Ekrānuzņēmumi',
    filterAll: 'Visi',
    filterProducts: 'Produkti',
    filterPlatforms: 'Platformas',
    filterMobile: 'Mobilās',
    filterCollab: 'Sadarbības',
    filterEducation: 'Izglītība',
    filterEcom: 'E-komercija',
    filterWip: 'Izstrādē',
    consoleLive: 'live',
    consoleWip: 'izstrādē',
    consoleSchools: '3 koledžu grupas',
    menuOpen: 'Izvēlne',
    menuClose: 'Aizvērt',
  },
};

export function useHomeT(lang) {
  return homeStrings[lang === 'lv' ? 'lv' : 'en'];
}
